export default {
  viewAccessLogs_description:
    "Autorisation de voir l'historique des personnes qui ont accédé à la plateforme Insights.",
  manageUsers_description:
    'Autorisation de gérer les utilisateurs dans la plateforme Insights.',
  accessApplicantsResults_description: `Permet aux utilisateurs d'accéder à la fois à "Admissions > Résultats des évaluations" et à "Admissions > Télécharger les résultats des évaluations"`,
  takeDuet_description:
    "Permet aux utilisateurs de remplir l'évaluation Duet, ce qui contribue à définir le profil de l'établissement.",
  viewDuetProfile_description:
    'Permet aux utilisateurs de consulter le profil Duet de leur programme.',
  passthrough_description:
    "Permet aux utilisateurs d'<strong>Analytics</strong> de revenir à l'ancien système Analytics. Pour ce faire, l'utilisateur doit disposer d'un compte correspondant dans l'ancien système Analytics. Obligatoire pour l'accès au MSPE.",
  clinicalGatewayExamsViewer_description:
    'Permet aux utilisateurs de consulter les données des examens cliniques de passerelle et les tableaux de bord correspondants.',
  courseEvaluationViewer_description:
    "Permet aux utilisateurs de consulter les données d'évaluation du cours.",
  examViewer_description:
    'Permet aux utilisateurs de consulter les données internes relatives aux examens et les tableaux de bord correspondants du programme Examsoft.',
  gradesDataViewer_description:
    'Permet aux utilisateurs de consulter les données sur les notes des apprenants et les tableaux de bord/visualisations correspondants.',
  studentAssessmentViewer_description:
    "Permet aux utilisateurs de consulter tous les tableaux de bord/visualisations contenant des données d'évaluation pour lesquelles un étudiant/apprenant est la personne cible.",
  matriculationDataViewer_description:
    "Permet aux utilisateurs de consulter les données relatives à l'inscription et les tableaux de bord/filtres correspondants concernant un apprenant.",
  nbmeSubjectExamsViewer_description:
    'Permet aux utilisateurs de consulter les données relatives aux examens des sujets provenant du NBME et les tableaux de bord et les visualisations correspondants.',
  preclinicalGatewayExamsViewer_description:
    'Permet aux utilisateurs de consulter les données relatives aux examens précliniques de passerelle et les tableaux de bord correspondants.',
  residencyMatchDataViewer_description:
    'Permet aux utilisateurs de consulter les données sur le placement en résidence et les tableaux de bord et les visualisations correspondants.',
  manageSnapshotReviewers_description:
    "Permet aux utilisateurs d'assigner les entrevues aux examinateurs et d'évaluer toutes les entrevues.",
  internal_description:
    "Permet aux utilisateurs d'accéder à des tableaux de bord internes (réservés aux employés) pour effectuer des actions de diagnostic."
};
